import { ProductLeadPopupComponent } from './../product-lead-popup/product-lead-popup.component';
import { Component, OnInit,Input} from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { HttpService } from 'app/shared/services/http.service';
import * as emiGlobals from 'app/globals';

@Component({
  selector: 'app-product-listing-page',
  templateUrl: './product-listing-page.component.html',
  styleUrls: ['./product-listing-page.component.css']
})
export class ProductListingPageComponent implements OnInit {
  @Input() questions;
  @Input() pageData;
  @Input() page;
  @Input() products;
  @Input() subcategory;
  subCategoryFilter='';
  subProductId: string;
  productIdList: any;
  productList = [];
  dataList = [];

  constructor(
    private modalService: NgbModal, public httpService: HttpService
  ) { }

  ngOnInit() {
  //   console.log('0000000000' , this.page);
  //   this.subProductId = this.page.sub_product_id;
  //   if (this.subProductId) {
  //   this.productIdList = this.subProductId.split(',');
  //   this.productIdList.forEach(element => {
  //   this.httpService.getById(emiGlobals.ProductUrl + '/' + element).subscribe(data => {
  //    this.dataList = data;
  //    this.dataList.forEach(result => {
  //     this.productList.push({
  //       'name': result.product
  //      });
  //    });
  //   });
  //   });
  // }
  }

  openThisOffer(product) {
    localStorage.setItem('choosen_product', JSON.stringify(product));
    localStorage.setItem('page-questions', JSON.stringify(this.questions));
    const modalRef = this.modalService.open(ProductLeadPopupComponent,{ size: 'lg',windowClass:'loan-lead-pop-up' });
  }
  filterTags(type, tag) {
     if (type == 'subcategory') {
      this.subCategoryFilter=tag
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/products/product-listing-page/product-listing-page.component.ts